import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { DesignToken } from '../base/core';

interface Props extends React.PropsWithChildren {
  className?: string;
}

const ProjectName: React.FC<Props> = ({ className, children }) => {
  return <span className={className}>{children}</span>;
};

export default muiStyled(ProjectName)(
  ({ theme }) => css`
    font-weight: 700;
    font-size: 14px;
    color: ${DesignToken.textPrimary};
    display: flex;
    align-items: center;
  `
);
